import "./App.css";
import "animate.css/animate.min.css";
// react
import { useState, useEffect, createContext } from "react";
// font
import WebFont from "webfontloader";

// sections
import Hero from "./sections/Hero";
import About from "./sections/About";
import Contact from "./sections/Contact";
import Skills from "./sections/Skills";
import Projects from "./sections/Projects";
// components
import Header from "./components/Header";

const navList = [
  {
    text: "hero",
    url: "/",
  },
  {
    text: "About",
    url: "#about",
  },
  {
    text: "Skills & Tools",
    url: "#skills",
  },
  {
    text: "Projects",
    url: "#projects",
  },
  {
    text: "Be In Touch",
    url: "#contact",
  },
];

export const globalStates = createContext();

function App() {
  const [sectionInView, setSectionInView] = useState(0);
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Mulish"],
      },
    });
  }, []);

  return (
    <div
      className="overflow-hidden "
      style={{
        fontFamily: '"Mulish", sans-serif',
        fontWeight: 600,
      }}
    >
      <globalStates.Provider
        value={{ sectionInView, setSectionInView, setShowHeader, showHeader }}
      >
        <Header show={showHeader} navList={navList} />

        <Hero navList={navList} setShowHeader={setShowHeader} />
        <About />
        <Skills />
        <Projects />
        <Contact />
      </globalStates.Provider>
    </div>
  );
}

export default App;
